import React, { useState } from 'react';
import { Dialog, FlatButton } from 'material-ui';

const styles = {
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 20px 0 10px' },
        buttonStyle: { height: '25px', lineHeight: '25px' },
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: '8px',
        padding: '16px 0',
    },
    link: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '50px',
        backgroundColor: '#2196F3',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '4px',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
    },
    linkOpened: {
        backgroundColor: '#4CAF50',
    },
    linkHover: {
        backgroundColor: '#1976D2',
    },
    hint: {
        color: '#666',
        fontSize: '13px',
        marginBottom: '8px',
    },
};

/**
 * opens emails as gazetter!!! tabs via middle click
 * @param {{ letterIds: string[], open?: boolean, handleOpen: Function }} props
 */
function OpenAll({ letterIds = [], open = false, handleOpen }) {
    const [openedIds, setOpenedIds] = useState(new Set());

    const handleLinkClick = (id) => {
        setOpenedIds(prev => new Set([...prev, id]));
    };

    const handleClose = () => {
        handleOpen();
        // setOpenedIds(new Set());
    };

    const dialogActions = [
        <FlatButton
            key="close"
            label="Close"
            onClick={handleClose}
        />,
    ];

    return (
        <React.Fragment>

            <Dialog
                title={`Middle-click to open in background (${letterIds.length} emails)`}
                actions={dialogActions}
                modal={false}
                open={open}
                onRequestClose={handleClose}
                contentStyle={{ maxWidth: '500px' }}
                autoScrollBodyContent={false}
                bodyStyle={{ overflowY: 'auto' }}
            >
                <p style={styles.hint}>
                    Middle-click (Ctrl+click or ⌘+click) on each number to open in background tab.
                    Green --- already opened.
                </p>
                <div style={styles.grid}>
                    {letterIds.map((id, index) => {
                        const isOpened = openedIds.has(id);
                        return (
                            <a
                                key={id}
                                href={`/${id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={e => handleLinkClick(id, e)}
                                onAuxClick={e => handleLinkClick(id, e)}
                                style={{
                                    ...styles.link,
                                    ...(isOpened ? styles.linkOpened : {}),
                                }}
                            >
                                {index + 1}
                            </a>
                        );
                    })}
                </div>
            </Dialog>
        </React.Fragment>
    );
}

export default OpenAll;



// WEBPACK FOOTER //
// ./app/components/Letters/List/OpenAll.jsx